export default __webpack_public_path__ + "static/media/Freddy.5740818d.mp3";